// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import type { ValidationRules } from "@lg/shared";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { ProxyTargetSymbol } from "@lg/shared/for-apps";
import { Semaphore } from "@lg/shared/for-apps";
import { memoize } from "@lg/shared/for-apps";
import { NgSharedModule } from "@lg/ng-shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";
import { MainLayout as Orders__MainLayout } from "../Orders/MainLayout.js";
import { Tasks as Orders__Tasks } from "../Orders/Tasks.js";

interface Properties {
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Orders-Home',
    templateUrl: './Home.html',
    styleUrls: ['./Home.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgSharedModule,
        Orders__MainLayout,
        Orders__Tasks
    ],
})
export class Home extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Orders.Home';
    $isDialog = false;
    $Modules = $Modules;
    Orders = Orders;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {

    };
    readonly screen =
        ((component: typeof this) => {
            return {

            }
        })(this)
        ;

    get $inputs() {
        return {

        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {

        }
    }
}
